<div [ngClass]="{ sidebar: !isCollapseNav, 'sidebar-collapsed': isCollapseNav }">
    <div class="sidebar-content">
        <div class="d-flex align-items-center sidebar-header-logo mb-4" [ngClass]="!isCollapseNav ? 'justify-content-between' : 'justify-content-center'">
            <img *ngIf="!isCollapseNav" [src]="logo" [ngClass]="isRiyadTenant ? 'riyad-logo' : ''" />
            <div (click)="toggleCollapseNav()" class="mt-2 side-bar-toggle cursor-pointer side-bar-toggle-icon">
                <mat-icon class="sidebar-icon-color">menu</mat-icon>
            </div>
        </div>

        <mat-list>
            <ng-container *ngFor="let item of menuItems">
                <span *ngIf="!isCollapseNav && item.section" class="sidebar-sub-menu">{{ item.section }}</span>
                <span *ngIf="isCollapseNav && item.section" class="sidebar-sub-menu"></span>

                <div *appAccessControlHideElementDirective="item.permissions">
                    <mat-list-item
                        *ngIf="(!isSubAgent || (isSubAgent && item.hideForSubAgent !== true)) && (!isSuperAgent || (isSuperAgent && item.hideForSuperAgent !== true))"
                        class="sidebar-item px-2"
                        [routerLink]="item.panelId ? null : item.link"
                        routerLinkActive="active"
                        [matTooltip]="isCollapseNav ? item.title : ''"
                        matTooltipClass="rounded-pill"
                        (click)="item.panelId ? openPanelItem(item) : onMenuItemClick()"
                    >
                        <div class="sidebar-item-content">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-icon
                                    class="side-bar-icon"
                                    [ngClass]="item.icon"
                                    [svgIcon]="item.useFontIcon ? '' : item.icon"
                                    [fontIcon]="item.useFontIcon ? item.icon : ''"
                                ></mat-icon>
                                <span *ngIf="!isCollapseNav">{{ item.title }}</span>
                            </div>
                        </div>
                    </mat-list-item>
                </div>
            </ng-container>
        </mat-list>

        <mat-list class="mt-auto">
            <ng-container *ngFor="let item of lowerMenuItems">
                <span *ngIf="!isCollapseNav && item.section" class="sidebar-sub-menu">{{ item.section }}</span>
                <span *ngIf="isCollapseNav && item.section" class="sidebar-sub-menu"></span>

                <div *appAccessControlHideElementDirective="item.permissions">
                    <mat-list-item
                        *ngIf="(!isSubAgent || (isSubAgent && item.hideForSubAgent !== true)) && (!isSuperAgent || (isSuperAgent && item.hideForSuperAgent !== true))"
                        class="sidebar-item px-2"
                        [routerLink]="item.panelId ? null : item.link"
                        routerLinkActive="active"
                        [matTooltip]="isCollapseNav ? item.title : ''"
                        matTooltipClass="rounded-pill"
                        (click)="item.panelId ? openPanelItem(item) : onMenuItemClick()"
                    >
                        <div class="sidebar-item-content">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-icon
                                    class="side-bar-icon"
                                    [ngClass]="item.icon"
                                    [svgIcon]="item.useFontIcon ? '' : item.icon"
                                    [fontIcon]="item.useFontIcon ? item.icon : ''"
                                ></mat-icon>
                                <span *ngIf="!isCollapseNav">{{ item.title }}</span>
                            </div>
                        </div>
                    </mat-list-item>
                </div>
            </ng-container>
        </mat-list>
    </div>
</div>
